import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TealiumAnalyticsEvent, TealiumAnalyticsService, TealiumConstants } from '@ddt-web/analytics';

import { ModelsExperienceFilters } from '../../models';

@Component({
	selector: 'mb-filter-card',
	templateUrl: './filter-card.component.html',
	styleUrls: ['./filter-card.component.scss']
})
export class ModelsExperienceFilterCardComponent implements OnChanges {

	@Input() public filter: ModelsExperienceFilters;
	@Input() public selectedFilter: ModelsExperienceFilters;
	@Input() public icon: string;
	@Output() public onSelect: EventEmitter<any> = new EventEmitter<any>();

	public isChecked: boolean = false;

	constructor(private tealiumAnalyticsService: TealiumAnalyticsService) { }

	public ngOnChanges(): void {
		this.isChecked = this?.selectedFilter?.meFilterId === this.filter.meFilterId;
	}

	public applyFilter(checkedFilter): void {
		this.isChecked = !this.isChecked;

		const eventName = TealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME + ':' + TealiumConstants.MODELS_EXPERIENCE_EVENTS.FIND_AND_COMPARE_PAGE + `:highlighted filter:${checkedFilter.meFilterId}:${this.isChecked ? 'checked' : 'unchecked'}`;
		this.tealiumAnalyticsService.trackEventTealium(new TealiumAnalyticsEvent(eventName, { toolName: TealiumConstants.TOOL_NAMES.MODELS_EXPERIENCE }));

		this.onSelect.emit({ filter: checkedFilter, checked: this.isChecked });
	}
}
